/* eslint-disable no-unused-vars */

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';

const URL = 'intern-service/profile/skill/section-data';

// Create the API using createApi
export const GetSkillsAndGoalsApi = createApi({
  reducerPath: 'GetSkillsAndGoalsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['skill-goals'],
  staleTime: 1,
  endpoints: (builder) => ({
    getSkill: builder.query({
      query: () => ({ url: URL, method: 'GET' }),
      providesTags: ['skill-goals'],
    }),
    saveSkillstoImprove: builder.mutation({
      query: (data) => {
        return { url: 'intern-service/profile/skill/v2/enhance', method: 'PUT', body: data };
      },
      invalidatesTags: ['skill-goals'],
    }),
    saveSkillstoLearn: builder.mutation({
      query: (data) => {
        return {
          url: 'intern-service/profile/skill/develop',
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['skill-goals'],
    }),
    saveProjectId: builder.mutation({
      query: (data) => {
        return {
          url: 'intern-service/application/skill-goals/interested-projects',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['skill-goals'],
    }),
    saveGoalsAndInterests: builder.mutation({
      query: (data) => {
        return {
          url: 'intern-service/profile/skill/introduction-text',
          method: 'PATCH',
          body: data,
        };
      },
      invalidatesTags: ['skill-goals'],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetSkillQuery,
  useSaveSkillstoImproveMutation,
  useSaveSkillstoLearnMutation,
  useSaveProjectIdMutation,
  useSaveGoalsAndInterestsMutation,
} = GetSkillsAndGoalsApi;
// Export the auto-generated hooks and reducer
export default GetSkillsAndGoalsApi.reducer;
